import { useMemo } from 'react';

import type { VisitorCustomFieldConfig } from 'application-types';
import {
  BASE_FIELD_KEYS,
  type FormCustomFieldColumn,
} from '../flatfile/workbook';

const EMPTY_FORM_CUSTOM_FIELD_COLUMNS: FormCustomFieldColumn[] = [];

export function useFormCustomFieldColumns(
  customFieldConfigs: VisitorCustomFieldConfig[] | undefined,
  customFieldIds: string[] | undefined
): {
  formCustomFieldColumns: FormCustomFieldColumn[];
} {
  const formCustomFieldColumns = useMemo((): FormCustomFieldColumn[] => {
    if (!customFieldIds?.length || !customFieldConfigs?.length) {
      return EMPTY_FORM_CUSTOM_FIELD_COLUMNS;
    }

    const customFieldConfigById = new Map(
      customFieldConfigs!.map(config => [config.id, config])
    );
    const columns = customFieldIds
      .map(id => customFieldConfigById.get(id))
      .filter((config): config is NonNullable<typeof config> => config != null)
      .filter(config => config.isEnabled)
      .filter(config => !BASE_FIELD_KEYS.has(config.fieldKey))
      .map(config => ({
        fieldKey: config.fieldKey,
        fieldName: config.fieldName,
        customFieldConfigId: config.id,
        fieldType: config.fieldType,
        options: config.options?.length ? config.options : undefined,
      }));

    return columns.length === 0 ? EMPTY_FORM_CUSTOM_FIELD_COLUMNS : columns;
  }, [customFieldIds, customFieldConfigs]);

  return { formCustomFieldColumns };
}
